export default {
	index: {
		path: '/',
		title: '首页',
	},
	login: {
		path: '/login',
		title: '登录',
	},
	home: {
		path: '/home',
	},
}
